export default __webpack_public_path__ + "static/project-video-26a16b956af1c1f9648b657b1d33dea3.jpg";